// Colors extracted from _colors.scss
const colors = {
  white: '#fff',
  black: '#000'
}

export default colors
